var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grm-loading-component" }, [
    _c("div", { staticClass: "grm-loading" }, [
      _c("img", {
        attrs: {
          width: "100",
          height: "auto",
          alt: "로딩 이미지",
          src:
            _vm.ux.loadingImagePath ||
            require("@/assets/images/loading_gooroomee.gif"),
        },
      }),
    ]),
    _vm.msg && _vm.msg !== ""
      ? _c("div", {
          staticStyle: {
            color: "#fff",
            "font-size": "14px",
            "text-shadow": "2px 2px 2px black",
          },
          domProps: { innerHTML: _vm._s(_vm.msg) },
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }